module.exports = __webpack_public_path__ + "img/bus.5b26e3eb.png";